import theme from "./SYMPHONY_3.1";

const common_theme_elements = {
  MuiCssBaseline: {
    styleOverrides: {
      "*::-webkit-scrollbar": {
        height: "8px",
        width: "8px",
      },
      "*::-webkit-scrollbar-track": {
        background: theme.palette.UI.grey_98,
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.UI.grey_300,
        borderRadius: "100px",
        opacity: "50%",
        "&:hover": {
          backgroundColor: theme.palette.UI.black,
        },
      },
      "*::-webkit-scrollbar-thumb:horizontal": {
        width: "8px",
        height: "300px",
        backgroundColor: theme.palette.UI.grey_300,
        backgroundClip: "padding-box",
        // borderRight: "16px white solid",
        "&:hover": {
          backgroundColor: theme.palette.UI.black,
        },
      },
    },
  },
};
export default common_theme_elements;
